import { useQuery } from "@tanstack/react-query";
import { getUserInformation } from "../../services/users";

const useGetInformation = (id: number) => {
    return useQuery({
        queryKey: ["immigrants", id],
        queryFn: () => getUserInformation(id),
        staleTime: Infinity,
    });
}

export default useGetInformation;